/**
 * Created by vsliwka on 13/09/2017.
 */
export class AttachedFileModel {
  public id: number = null;
  public name: string;
  public path: string;
  public url: string;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
